<template lang="pug">
div
  .thank-you-box
    b-row
      b-col.text-center
        img(:src="wuwowThankyouPng" alt="WUWOW 線上英語教學 感謝您")
    b-row.mt-5
      b-col
        span.thank-you-content
          | 謝謝您提供的訊息，我們已經收到您的資料！
          br
          | 我們會盡快安排專員與您聯絡！
    b-row.mt-5
      b-col
        b-button.go-back-home-btn(@click="backToHome()" variant="primary") 返回WUWOW Jr官網
</template>

<script>
import wuwowThankyouPng from '@/assets/wuwow_ty.png';
export default {
  name: 'ThankYouPage',

  data() {
    return {
      wuwowThankyouPng: wuwowThankyouPng,
    };
  },

  mounted(){
  },

  methods: {
    backToHome(){
      this.$router.push({ path: '/' });
    },
  },
};
</script>
<style scoped>
.thank-you-box{
  height: 100vh;
  text-align: center;
  background-color: #F5F5F5;
  background-image: url(~@/assets/thank_you_bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.thank-you-content{
  font-size: 18px;
  color: var( --text-light-color );
}
.go-back-home-btn{
  font-size: 16px;
  padding: 15px 80px;
}
</style>
